<template>
    <div>
        <div v-if="item.itemId">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <item-release @dropNote="handleDrop($event)" :item="item" :release="item.release" :itemNotes="item.notes" @updateRelease="doReleaseUpdate($event)" @updateNotes="doNotesUpdate($event)" :noteDropped="noteDropped"></item-release>
                    </b-col>
                </b-row>

                <b-row class="mb-3 mt-3">
                    <!--<b-col xl="7" lg="12">-->
                        <!--<notes :notes="item.notes" :noteDropped="noteDropped" @update="doNotesUpdate($event)"></notes>-->
                    <!--</b-col>-->
                </b-row>

                <b-row>
                    <b-col>
                        <media-list :media="item.release.media" @update="updateMedia" @updateSpeed="handleSpeedUpdate" />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <h5 class="text-secondary">Listings</h5>
                    </b-col>

                    <b-col align="right">
                        <b-dropdown size="sm" variant="outline-secondary" toggle-class="text-decoration-none" no-caret>
                            <template #button-content>
                                <b-icon-caret-down></b-icon-caret-down>
                            </template>

                            <b-dropdown-item @click="addListing('active')">Active</b-dropdown-item>
                            <b-dropdown-item @click="addListing('inactive')">Inactive</b-dropdown-item>
                            <b-dropdown-item @click="addListing('cover')">Cover</b-dropdown-item>
                            <b-dropdown-item @click="addListing('disc')">Disc</b-dropdown-item>
                        </b-dropdown>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col v-for="(listing, index) in item.listing" v-bind:key="index" sm="12">
                        <item-listing :listing="listing"
                                      :index="index"
                                      :itemId="item.itemId"
                                      :mediaType="primaryMediaType()"
                                      :speed="primaryMediaSpeed"
                                      :mediaSize="primaryMediaSize()"
                                      :allListings="item.listing"
                                      @dropNote="handleDrop($event)"
                                      @update="doUpdate('listing', $event, index)"
                                      @showImages="showImages($event)"
                                      @removeListing="removeListing($event)"></item-listing>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col xl="7" lg="12">
                        <internal-notes :notes="item.notes" @update="doInternalNotesUpdate($event)"></internal-notes>
                    </b-col>

                    <b-col>
                        <suppressed :suppressed="item.suppressed" @update="doSuppressedUpdate('suppressed', $event)"></suppressed>
                    </b-col>
                </b-row>
            </b-container>

            <b-modal centered
                     size="lg"
                     id="imageModal"
                     hide-footer
                     hide-header
                     v-model="showImageModal">
                <images :images="modalImages"></images>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import ItemRelease from "./ItemRelease";
    import ItemListing from "./ItemListing";
    // import Notes from "./Notes";
    import InternalNotes from "./InternalNotes";
    import Suppressed from "./Suppressed";
    import Images from "./Images";
    import MediaList from "./MediaList";

    export default {
        name: "ItemDetails",
        props: [ 'item' ],
        components: { ItemRelease, ItemListing, InternalNotes, Suppressed, Images, MediaList },
        data() {
            return {
                noteDropped: '',
                showImageModal: false,
                modalImages: [],
            }
        },
        computed: {
            primaryMediaSpeed() {
                if (this.item.release.media.length > 0 && this.item.release.media[0].speed) {
                    return this.item.release.media[0].speed;
                }
                return null;
            },
        },
        methods: {
            showImages(images) {
                this.modalImages = images;
                this.showImageModal = true;
            },
            handleDrop(event) {
                this.noteDropped = event;
            },
            handleSpeedUpdate(speed) {
                console.log('ItemDetails received speed update:', speed);
                if (this.item.release.media.length > 0) {
                    this.item.release.media[0].speed = speed;
                    this.$emit('updateItemDetails', { 
                        key: 'media', 
                        obj: this.item.release.media,
                        parent: 'release'
                    });
                }
            },
            doNotesUpdate(data) {
                this.$emit('updateNotes', data);
            },
            doInternalNotesUpdate(data) {
                this.$emit('updateInternalNotes', data);
            },
            doUpdate(key, obj, index) {
                this.item[key][index] = obj;
                this.$emit('updateItemDetails', { key: key, obj: this.item[key] });
            },
            doSuppressedUpdate(key, obj) {
                this.item[key]= obj;
                this.$emit('updateItemDetails', { key: key, obj: this.item[key] });
            },
            doReleaseUpdate(data) {
                this.$emit('updateItemDetails', { key: data.key, obj: data.obj, parent: 'release' });
            },
            addListing(type) {
                let date = Date.now();
                let listing = {
                    type: type,
                    count: 1,
                    location: null,
                    price: 0,
                    condition: [{
                        subject: null,
                        grade: null,
                    }],
                    images: [],
                    soundclips: [],
                    username: this.$auth.user.nickname,
                    date: date,
                };
                const newArray = [...this.item.listing];
                newArray.push(listing);
                this.$set(this.item, 'listing', newArray);
            },
            removeListing(index) {
                this.item.listing.splice(index, 1);
            },
            primaryMediaType() {
                if (this.item.release.media.length > 0 && this.item.release.media[0].duration) {
                    return this.item.release.media[0].duration;
                }
                return null;
            },
            updateMedia(newMedia) {
                this.item.release.media = newMedia;
            },
        },
    }
</script>

<style>
    .btn-outline-secondary {
        border-color: #ced4da !important;
    }
</style>